// Candidate replay bounds; activated runtime capacity requires measured acceptance.
export const FRAME_DELIVERY_POLICY = Object.freeze({
  maxEvents: 64, maxBytes: 262144, visibleAgeMs: 50, hiddenAgeMs: 250,
  recoveryCooldownMs: 5000, maxShapeNodes: 512, maxShapeDepth: 8,
});
